/* @ngInject */
export default function ($scope, $stateParams, LayoutService, toastr, $state, Enquiries, StaffReportsEnquiriesService, AuthService, PreferencesService) {
	AuthService.redirectIfUnauthorized('view-enquiries', 'splash.home');

	$scope.enquiryId = $stateParams.enquiryId;

	LayoutService.setTitle('Update Enquiry');
	LayoutService.getPageHeader()
	             .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-check"></i> Update</button>');
	LayoutService.getPageHeader()
	             .setBreadcrumbs([
		             {
			             route:       'staff.dashboard',
			             displayName: 'Dashboard',
		             },
		             {
			             route:       null,
			             displayName: 'Reports',
		             },
		             {
			             route:       'staff.reports.enquiries.root',
			             displayName: 'Enquiries Report',
		             },
		             {
			             route:       `staff.reports.enquiries.view({ enquiryId: "${$scope.enquiryId}" })`,
			             displayName: 'Update Enquiry',
		             },
	             ]);

	$scope.loading             = true;
	$scope.loadingEnquiry      = true;
	$scope.loadingCaseManagers = true;

	$scope.dateTimeFormat = PreferencesService.getDateTimePreference();

	$scope.caseManagers = [];

	$scope.regions = [
		'NSW - Far North coast',
		'NSW - New England',
		'NSW - Mid North Coast',
		'NSW - Far West',
		'NSW - Hunter',
		'NSW - Hunter (STOCKTON)',
		'NSW - Hunter (BARNSLEY)',
		'NSW - Central West',
		'NSW - Central Coast',
		'Syd - Northern',
		'Syd - South East',
		'Syd - Inner West',
		'Syd - South West',
		'Syd - West/Prospect',
		'NSW - Nepean',
		'NSW - Illawarra',
		'NSW - Riverina Murray',
		'NSW - Southern Highlands',
		'UNKNOWN',
		'QLD',
		'VIC',
		'SA',
	];

	$scope.programs = {
		'Allianz WC':                     'Compensables',
		'Australia Unity':                'Brokerage',
		'CGU WC':                         'Compensables',
		'Disability SA':                  'Disability SA',
		'EML':                            'Compensables',
		'GIO WC':                         'Compensables',
		'Icare LTC NSW':                  'Icare',
		'Icare Dust Diseases':            'Icare',
		'Icare Workers Care Program':     'Icare',
		'Icare Workers Insurance':        'Icare',
		'LSA SA':                         'LSA SA',
		'Mei-Wel':                        'Compensables',
		'NDIS':                           'NDIA',
		'OTHER / TBC':                    'Other',
		'Paraquad':                       'Brokerage',
		'Private':                        'Private',
		'QBE WC':                         'Compensables',
		'Spinal Cord Injuries Australia': 'Brokerage',
		'TAC':                            'TAC',
		'Zurich CTP':                     'Compensables',
	};

	$scope.enquiryMethods = [
		'Email',
		'Phone',
	];

	$scope.referredToDanielle = [
		'Yes',
		'No',
	];

	$scope.referred = [
		'Yes',
		'No',
		'TBC',
	];

	$scope.reasonNotReferred = [
		'AAC do not currently service area/region',
		'AAC unable to start in requested time frame',
		'AAC declined due to length of service',
		'AAC did not accept enquiry - OTHER',
		'Cost for service too high',
		'Service request out of AAC scope',
		'Attendant Care no longer required (due to facility, after initial assessment)',
		'Another Service Provider was selected due to AAC\'s 2hr minimum charge (outside LTCSA)',
		'Another Service Provider was selected - reason to be added in comment',
		'Another Service Provider was selected by an external party',
		'Another Service Provider was selected - reason unknown',
		'No response from enquirer after quote/information provided',
		'Staff availability to low in the area',
	];

	$scope.defaults = {
		role:        [
			'Case Manager',
			'Coordinator',
			'Occupational Therapist',
			'Daughter',
			'Son',
			'Sister',
			'Brother',
			'Mother',
			'Father',
			'Wife',
			'Husband',
			'Family',
			'TBC',
			'NDIA Lawyer',
		],
		serviceType: [
			'PC',
			'DA',
			'Community Access',
			'Transport',
			'RN',
			'TBA',
			'One Off Care and Support Needs Assessment',
		],
		days:        [
			'7 days',
			'Weekdays',
			'Weekends',
			'Unknown',
		],
	};

	$scope.refresh = () => {
		$scope.loading             = true;
		$scope.loadingEnquiry      = true;
		$scope.loadingCaseManagers = true;

		Enquiries.one($scope.enquiryId)
		         .get({
			         include: 'internalCaseManager,quotes',
		         })
		         .then((enquiry) => {
			         $scope.quotes  = enquiry.quotes;
			         $scope.enquiry = Enquiries.mapJSONToObject(enquiry);

			         LayoutService.reset();

			         LayoutService.setTitle([
				         `Update ${$scope.enquiry.serviceUser.firstName} ${$scope.enquiry.serviceUser.lastName}`,
			         ]);

			         LayoutService.getPageHeader()
			                      .setBreadcrumbs([
				                      {
					                      route:       'staff.dashboard',
					                      displayName: 'Dashboard',
				                      },
				                      {
					                      route:       null,
					                      displayName: 'Reports',
				                      },
				                      {
					                      route:       'staff.reports.enquiries.root',
					                      displayName: 'Enquiries Report',
				                      },
				                      {
					                      route:       `staff.reports.enquiries.view({ enquiryId: "${$scope.enquiryId}" })`,
					                      displayName: `Update ${$scope.enquiry.serviceUser.firstName} ${$scope.enquiry.serviceUser.lastName}`,
				                      },
			                      ]);

			         LayoutService.getPageHeader()
			                      .setActionButton('<button type="button" class="btn btn-primary pull-right"><i class="fa fa-check"></i> Update</button>');

			         LayoutService.getPageHeader()
			                      .onClicked(() => {
				                      $scope.save();
			                      });

			         $scope.loadingEnquiry = false;

			         if (!$scope.loadingCaseManagers) {
				         $scope.loading = false;
			         }
		         })
		         .catch((error) => {
			         toastr.clear();
			         toastr.error('There was an error while loading the enquiry, please try again.', 'Error');

			         $state.go('staff.reports.enquiries.root');

			         $scope.loading = false;
		         });

		StaffReportsEnquiriesService
			.getCaseManagers()
			.then((data) => {
				$scope.caseManagers = data.data;

				$scope.loadingCaseManagers = false;

				if (!$scope.loadingEnquiry) {
					$scope.loading = false;
				}

				$scope.loading = false;
			})
			.catch((error) => {
				toastr.clear();
				toastr.error('There was an error while loading the case managers, please try again.', 'Error');

				$state.go('staff.reports.enquiries.root');

				$scope.loading = false;
			});
	};

	$scope.fundingProgramChanged = () => {
		const program = $scope.enquiry.funding.program;

		$scope.enquiry.funding.funder = $scope.programs[program];
	};

	$scope.enquiryReferredChanged = () => {
		if ($scope.enquiry.enquiry.referred !== 'No') {
			$scope.enquiry.enquiry.reasonNotReferred = '';
		}
	};

	$scope.save = () => {
		if ($scope.loading === false) {
			const enquiry = Enquiries.mapObjectToJSON($scope.enquiry);

			Enquiries
				.one($scope.enquiryId)
				.customPOST(enquiry)
				.then((data) => {
					toastr.clear();
					toastr.success('The enquiry was updated successfully.', 'Success');

					$state.go('staff.reports.enquiries.root');
				})
				.catch((data) => {
					toastr.clear();
					toastr.error('There was an error while updating the enquiry, please try again.', 'Error');
				});
		} else {
			toastr.clear();
			toastr.warning('You must wait for the page to load before updating your enquiry.');
		}
	};

	$scope.addDefaultServiceUserRole = (text) => {
		if ($scope.enquiry.serviceUser.role.length > 0) {
			$scope.enquiry.serviceUser.role += ', ' + text;
		} else {
			$scope.enquiry.serviceUser.role = text;
		}
	};

	$scope.addDefaultServiceType = (text) => {
		if ($scope.enquiry.service.type.length > 0) {
			$scope.enquiry.service.type += ', ' + text;
		} else {
			$scope.enquiry.service.type = text;
		}
	};

	$scope.addDefaultServiceDays = (text) => {
		if ($scope.enquiry.service.days.length > 0) {
			$scope.enquiry.service.days += ', ' + text;
		} else {
			$scope.enquiry.service.days = text;
		}
	};

	LayoutService.getPageHeader()
	             .onClicked($scope.save);

	$scope.refresh();
};


// WEBPACK FOOTER //
// ./src/js/endpoints/staff/reports/enquiries/view/controller.js